import { useParams } from 'react-router';

export const useCustomerRoutePrefix = (customPartnerId?: string, customCompanyId?: string) => {
  const { partnerId, companyId } = useParams();

  const mspId = customPartnerId ?? partnerId;
  const customerId = customCompanyId ?? companyId;

  if (!(mspId && customerId)) throw new Error('Missing ids');

  const prefix = `/msps/${mspId}/companies/${customerId}`;

  return prefix;
};
